import React from 'react';

import Card from '../Card/Card';
import CardDetail from '../Common/CardDetail/CardDetail';
import Button from '../../UI/Button/Button';

const creditCard = (props) => {

    console.log(props);

    let isActive = false;

    if (props.creditCardOriginalValue !== '' && props.creditCardValue !== '' && props.cvvValue !== '' && props.expiryDateValue !== '' && props.nameValue !== '') {
        isActive = true;
    }

    return (
        <React.Fragment>
            <div className={`mb-6`}>
                <Card 
                    cardType={props.cardType}
                    creditCardValue={props.creditCardOriginalValue}
                    expiryDateValue={props.expiryDateValue}
                    nameValue={props.nameValue}
                    cvvValue={props.cvvValue} />
            </div>
            <div className={`mb-6`}>
                <CardDetail 
                    creditCardChange={props.creditCardChange} 
                    expiryDateChange={props.expiryDateChange} 
                    nameChange={props.nameChange} 
                    cvvChange={props.cvvChange}
                    creditCardValue={props.creditCardValue}
                    expiryDateValue={props.expiryDateValue}
                    nameValue={props.nameValue}
                    cvvValue={props.cvvValue}
                    typeChange={props.typeChange}  />
            </div>
            <div className={`u-flex justify-content-between align-items-center mt-auto phone-f-column`}>
                <div className={`u-phoneWidth100Percent phone-mb-4`}></div>
                <div className={`u-phone-width100Percent`}> 
                    <Button disabled={!isActive} onClick={props.clicked} theme='Primary' type='Pay'>Pay Now</Button>
                </div>
            </div>
        </React.Fragment>
    );
}

export default creditCard;


// WEBPACK FOOTER //
// ./src/components/Payment/CreditCard/CreditCard.js